// TODO: i18n implementation to translate
// import { useEffect } from "react";
import { FoundationsSelectType } from '../Types/FoundationsTypes'
import { FoundationsTooltip } from './tooltip'
import { FoundationsGeneric } from './FoundationsGeneric'

export function FoundationsSelect(props: FoundationsSelectType) {
    function handleInput(e: any) {
        props.onChange !== undefined ? props.onChange(e) : () => {}
    }

    return (
        <FoundationsGeneric
            id={props.id + '_container'}
            customStyle={props.customStyle}
            classes={props.classes}
        >
            {props.labelText !== undefined && (
                <label className={(props.labelClasses || '') + ' col-form-label'}>
                    {props.labelText}
                    {props.optional && <small className="text-muted">(optional)</small>}
                    {props.isAsterisk && <span style={{ color: 'red' }}>&#42;</span>}
                </label>
            )}

            <span className={props.containerClasses || ''}>
                <select
                    name={props.name}
                    id={props.id}
                    className={(props.selectClasses || '') + ' ' /*+select2hidden_class*/}
                    disabled={props.disabled ? true : false}
                    multiple={props.isMultiSelect ? true : false}
                    style={{ height: 'auto' }}
                    defaultValue={props.defaultValue}
                    data-hash={props.hash}
                    data-collection_index={props.collectionIndex}
                    data-is_text_value={props.isTextValue}
                    onInput={handleInput}
                    {...(props.registerFunction
                        ? props.registerFunction(props.registerName, props.registerRules)
                        : {})}
                >
                    {props.placeHolder && (
                        <option value="" disabled>
                            {props.placeHolder}
                        </option>
                    )}
                    {props.children}
                    {/* TODO -> add rendering options from props.options if its defined*/}
                </select>
                {props.error && (
                    <div style={{ height: '17px' }}>
                        <label htmlFor={props.id} className="error field-validation-error d-block">
                            {'' + props.error}
                        </label>
                    </div>
                )}
            </span>
            {props.toolTipText !== undefined && (
                <div className="text-right info-icon d-inline-block">
                    <FoundationsTooltip
                        id={'tooltip_icon_' + props.id}
                        text={props.toolTipText}
                        style={{
                            transform: 'translate(30%, 10%)',
                            fontWeight: 'bold',
                        }}
                    />
                </div>
            )}
        </FoundationsGeneric>
    )
}
